/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'base-busi': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.4 10.893a.523.523 0 01-.523.523h-.517a.523.523 0 01-.523-.523V9.855H4.158v1.037a.523.523 0 01-.523.523h-.516a.523.523 0 01-.523-.523V9.855H0v4.27A1.875 1.875 0 001.875 16h12.25A1.875 1.875 0 0016 14.125v-4.27h-2.6zm.725-8.193H12v-.825A1.875 1.875 0 0010.123 0H5.877A1.875 1.875 0 004 1.875V2.7H1.875A1.875 1.875 0 000 4.579V8.34h2.6V7.3a.523.523 0 01.523-.523h.517a.523.523 0 01.523.523v1.04h7.683V7.3a.523.523 0 01.523-.523h.517a.523.523 0 01.514.523v1.04H16V4.579A1.875 1.875 0 0014.125 2.7zm-3.533 0H5.408v-.825a.469.469 0 01.469-.469h4.245a.469.469 0 01.469.469V2.7z" _fill="#212121"/>'
  }
})
